@if (contractForm) {
  <form [formGroup]="contractForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="mb-3 text-secondary col-12">
        <small class="form-text text-secondary">Les champs marqués d'un * sont obligatoires. </small>
      </div>
    </div>
    <div class="row">
      <!-- Dates -->
      <div class="mb-3 col-12 col-lg-6">
        <label class="text-secondary required">Date de début</label>
        <app-datepicker
          id="fieldBeginDate"
          formControlName="beginDate"
          [invalid]="submitted && (contractForm.errors?.datesOrder || contractForm.controls?.beginDate?.invalid)"
        ></app-datepicker>
        @if (submitted && contractForm.errors?.datesOrder) {
          <small class="form-text text-danger">La date de début est incohérente avec la date de fin.</small>
        }
        @if (submitted && !contractForm.controls?.beginDate?.errors?.required && contractForm.controls?.beginDate?.errors?.dateFormat) {
          <small class="form-text text-danger">La date de début est invalide.</small>
        }
        @if (submitted && contractForm.controls?.beginDate?.errors?.required) {
          <small class="form-text text-danger">La date de début est requise.</small>
        }
        @if (submitted && contractForm.errors?.overrideExistingContrat) {
          <small class="form-text text-danger col-12 error-ratio-input">Le contrat ne doit pas déborder sur le contrat précédent</small>
        }
        @if (contractForm.errors?.contratStillActive) {
          <small class="form-text text-danger col-12 error-ratio-input">Le contrat précédent n'a pas de date de fin</small>
        }
      </div>
      <div class="mb-3 col-12 col-lg-6">
        <label class="text-secondary">Date de fin</label>
        <app-datepicker
          id="fieldEndDate"
          formControlName="endDate"
          [invalid]="submitted && (contractForm.errors?.datesOrder || contractForm.controls?.endDate?.invalid)"
        ></app-datepicker>
        @if (submitted && contractForm.errors?.datesOrder) {
          <small class="form-text text-danger">La date de fin est incohérente avec la date de début.</small>
        }
        @if (submitted && !contractForm.controls?.endDate?.errors?.required && contractForm.controls?.endDate?.errors?.dateFormat) {
          <small class="form-text text-danger">La date de fin est invalide.</small>
        }
      </div>
    </div>
    <div formGroupName="checkConditions" class="mt-4">
      <!-- QuarterlyDeclarationRessources -->
      <label class="fw-bold required">Vérifications obligatoires par le référent :</label>
      <div class="row">
        <div class="col-8 col-lg-8">
          <label>Déclaration trimestrielle de ressources (DTR) à jour :</label>
        </div>
        <div class="col-2 col-lg-2">
          <div class="form-check form-check-inline">
            <input
              id="quarterlyDeclarationResourcesYes"
              type="radio"
              class="form-check-input"
              formControlName="quarterlyDeclarationResources"
              [value]="true"
            />
            <label for="quarterlyDeclarationResourcesYes" class="form-check-label">Oui</label>
          </div>
        </div>
        <div class="col-2 col-lg-2">
          <div class="form-check form-check-inline">
            <input
              id="quarterlyDeclarationResourcesNo"
              type="radio"
              class="form-check-input"
              formControlName="quarterlyDeclarationResources"
              [value]="false"
            />
            <label for="quarterlyDeclarationResourcesNo" class="form-check-label">Non</label>
          </div>
        </div>
        @if (submitted && checkConditionsForm.controls.quarterlyDeclarationResources.errors?.required) {
          <small class="form-text text-danger col-12 error-ratio-input">Le champ est requis.</small>
        }
      </div>
      <!-- ProfessionalResources -->
      <div class="row">
        <div class="col-8 col-lg-8">
          <label>Ressources professionnelles :</label>
        </div>
        <div class="col-2 col-lg-2">
          <div class="form-check form-check-inline">
            <input id="professionalResourcesYes" type="radio" class="form-check-input" formControlName="professionalResources" [value]="true" />
            <label for="professionalResourcesYes" class="form-check-label">Oui</label>
          </div>
        </div>
        <div class="col-2 col-lg-2">
          <div class="form-check form-check-inline">
            <input id="professionalResourcesNo" type="radio" class="form-check-input" formControlName="professionalResources" [value]="false" />
            <label for="professionalResourcesNo" class="form-check-label">Non</label>
          </div>
        </div>
        @if (submitted && checkConditionsForm.controls.professionalResources.errors?.required) {
          <small class="form-text text-danger col-12 error-ratio-input">Le champ est requis.</small>
        }
      </div>
      <!-- Other ressources -->
      <div class="row">
        <div class="col-8 col-lg-8">
          <label>Autres ressources (foyer) :</label>
        </div>
        <div class="col-2 col-lg-2">
          <div class="form-check form-check-inline">
            <input id="otherResourcesYes" type="radio" class="form-check-input" formControlName="otherResources" [value]="true" />
            <label for="otherResourcesYes" class="form-check-label">Oui</label>
          </div>
        </div>
        <div class="col-2 col-lg-2">
          <div class="form-check form-check-inline">
            <input id="otherResourcesNo" type="radio" class="form-check-input" formControlName="otherResources" [value]="false" />
            <label for="otherResourcesNo" class="form-check-label">Non</label>
          </div>
        </div>
        @if (submitted && checkConditionsForm.controls.otherResources.errors?.required) {
          <small class="form-text text-danger col-12 error-ratio-input">Le champ est requis.</small>
        }
      </div>
      <!-- Verification family situation -->
      <div class="row">
        <div class="col-8 col-lg-8">
          <label>Vérification de la situation familiale :</label>
        </div>
        <div class="col-2 col-lg-2">
          <div class="form-check form-check-inline">
            <input
              id="verificationFamilySituationYes"
              type="radio"
              class="form-check-input"
              formControlName="verificationFamilySituation"
              [value]="true"
            />
            <label for="verificationFamilySituationYes" class="form-check-label">Oui</label>
          </div>
        </div>
        <div class="col-2 col-lg-2">
          <div class="form-check form-check-inline">
            <input
              id="verificationFamilySituationNo"
              type="radio"
              class="form-check-input"
              formControlName="verificationFamilySituation"
              [value]="false"
            />
            <label for="verificationFamilySituationNo" class="form-check-label">Non</label>
          </div>
        </div>
        @if (submitted && checkConditionsForm.controls.verificationFamilySituation.errors?.required) {
          <small class="form-text text-danger col-12 error-ratio-input">Le champ est requis.</small>
        }
      </div>
      <!-- Verification CAF address -->
      <div class="row">
        <div class="col-8 col-lg-8">
          <label>Vérification adresse CAF :</label>
        </div>
        <div class="col-2 col-lg-2">
          <div class="form-check form-check-inline">
            <input id="verificationCAFAddressYes" type="radio" class="form-check-input" formControlName="verificationCAFAddress" [value]="true" />
            <label for="verificationCAFAddressYes" class="form-check-label">Oui</label>
          </div>
        </div>
        <div class="col-2 col-lg-2">
          <div class="form-check form-check-inline">
            <input id="verificationCAFAddressNo" type="radio" class="form-check-input" formControlName="verificationCAFAddress" [value]="false" />
            <label for="verificationCAFAddressNo" class="form-check-label">Non</label>
          </div>
        </div>
        @if (submitted && checkConditionsForm.controls.verificationCAFAddress.errors?.required) {
          <small class="form-text text-danger col-12 error-ratio-input">Le champ est requis.</small>
        }
      </div>
      <!-- Increased RSA -->
      <div class="row">
        <div class="col-8 col-lg-8">
          <label>RSA majoré (si oui, dérogation étude/formation non nécessaire) :</label>
        </div>
        <div class="col-2 col-lg-2">
          <div class="form-check form-check-inline">
            <input id="rsaIncreasedYes" type="radio" class="form-check-input" formControlName="rsaIncreased" [value]="true" />
            <label for="rsaIncreasedYes" class="form-check-label">Oui</label>
          </div>
        </div>
        <div class="col-2 col-lg-2">
          <div class="form-check form-check-inline">
            <input id="rsaIncreasedNo" type="radio" class="form-check-input" formControlName="rsaIncreased" [value]="false" />
            <label for="rsaIncreasedNo" class="form-check-label">Non</label>
          </div>
        </div>
        @if (submitted && checkConditionsForm.controls.rsaIncreased.errors?.required) {
          <small class="form-text text-danger col-12 error-ratio-input">Le champ est requis.</small>
        }
      </div>
      <!-- Beneficiary Status-->
      <div class="row">
        <div class="col-8 col-lg-8">
          <label>Statut bénéficiaire (si conjoint, dérogation étude/formation non nécessaire) :</label>
        </div>
        <div class="col-2 col-lg-2">
          <div class="form-check form-check-inline">
            <input
              id="beneficiaryStatusInCharge"
              type="radio"
              class="form-check-input"
              formControlName="beneficiaryStatus"
              [value]="StatutBeneficiaire.inCharge"
            />
            <label for="beneficiaryStatusInCharge" class="form-check-label">{{ StatutBeneficiaire.inCharge }}</label>
          </div>
        </div>
        <div class="col-2 col-lg-2">
          <div class="form-check form-check-inline">
            <input
              id="beneficiaryStatusPartner"
              type="radio"
              class="form-check-input"
              formControlName="beneficiaryStatus"
              [value]="StatutBeneficiaire.partner"
            />
            <label for="beneficiaryStatusPartner" class="form-check-label">{{ StatutBeneficiaire.partner }}</label>
          </div>
        </div>
        @if (submitted && checkConditionsForm.controls.rsaIncreased.errors?.required) {
          <small class="form-text text-danger col-12 error-ratio-input">Le champ est requis.</small>
        }
      </div>
    </div>
    <div class="mt-4">
      <p class="fw-bold">Diagnostic de situation</p>
      <p class="fw-bold mx-4">Contraintes identifiées</p>
      <ul>
        @if (assessment) {
          @if (assessment?.adminDifficulties) {
            <li>Administrative/juridique</li>
          }
          @if (assessment?.readingWritingDifficulties) {
            <li>Linguistique</li>
          }
          @if (assessment?.familyBarriers) {
            <li>Famille</li>
          }
          @if (assessment?.health) {
            <li>Santé</li>
          }
          @if (assessment?.financialDifficulties) {
            <li>Financière</li>
          }
          @if (assessment?.housing) {
            <li>Logement</li>
          }
          @if (assessment?.mobilityDifficulties) {
            <li>Mobilité</li>
          }
          @if (assessment?.numericDifficulties) {
            <li>Numérique</li>
          }
          @if (assessment?.professionalProjectHasDefinedCreationProject === false) {
            <li>Projet professionnel</li>
          }
          @if (assessment?.socialSatisfaction === false) {
            <li>Environnement social</li>
          }
        }
      </ul>
      <p class="fw-bold mx-4">Atouts, points forts</p>
      <ul>
        @if (assessment?.advantages; as advantages) {
          @for (advantage of advantages; track advantage.id) {
            <li>{{ advantage.asset.label }} : {{ advantage.description }}</li>
          }
        }
      </ul>
    </div>
    @if (recap) {
      <div class="row">
        <div class="col-12">
          <p class="fw-bold">Bilan du précédent contrat</p>
        </div>
        <div class="col-12">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Actions</th>
                <th>Réalisé</th>
                <th>Si non, pourquoi</th>
              </tr>
            </thead>
            <tbody>
              @for (action of recap; track $index) {
                <tr>
                  <td>{{ action.actionType }}</td>
                  <td>{{ action.fulfilled ? 'Oui' : action.fulfilled === false ? 'Non' : '' }}</td>
                  <td>{{ action.unfulfilledDetail }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }
    <div class="row">
      <div class="col-10">
        <p class="fw-bold">Plan d'actions</p>
        <p class="fst-italic">Saisir le plan d'actions par ordre de priorité</p>
      </div>
    </div>
    <div class="row">
      <app-dynamic-form
        #actions
        class="col-12"
        title=""
        [data]="actionsData"
        [showSeparator]="false"
        [fields]="fieldActions"
        noGroupText="Aucune action renseignée. Cliquez sur le bouton + pour en ajouter."
      >
        <ng-template let-groupIndex="groupIndex" let-group="group" let-groupRemoved="groupRemoved">
          <!-- Constraint -->
          <div class="text-secondary mb-1 col-12 col-lg-2" [formGroup]="group">
            <label class="required">Contrainte</label>
            <select
              class="form-select"
              formControlName="constraint"
              [class.is-invalid]="submitted && group?.controls?.constraint?.errors?.required"
              (change)="handleContraintChange(group)"
            >
              <option value="" hidden></option>
              @for (constraint of constraints; track constraint.id) {
                <option [ngValue]="constraint">{{ constraint.label }}</option>
              }
            </select>
            @if (submitted && group?.controls?.constraint?.errors?.required) {
              <small class="form-text text-danger">La contrainte est requise.</small>
            }
          </div>
          <!-- Action -->
          <div class="text-secondary mb-1 col-12 col-lg-4" [formGroup]="group">
            <label class="required">Action</label>
            <ng-select
              [items]="group.controls.constraint.value?.types"
              bindLabel="label"
              formControlName="actionType"
              class="auto-grow"
              [title]="group.controls.actionType.value?.label"
            ></ng-select>
            @if (submitted && group?.controls?.actionType?.errors?.required) {
              <small class="form-text text-danger">L'action est requise.</small>
            }
          </div>
          <!-- Deadline -->
          <div class="text-secondary mb-1 col-12 col-lg-3" [formGroup]="group">
            <label class="required">Date d'échéance</label>
            <app-datepicker formControlName="deadline" [invalid]="submitted && group.controls?.deadline?.invalid"></app-datepicker>
            @if (submitted && group?.controls?.deadline?.errors?.required) {
              <small class="form-text text-danger">La date d'échéance est requise.</small>
            }
          </div>
          <!-- Place -->
          <div class="text-secondary mb-1 col-12 col-lg-3" [formGroup]="group">
            <label>Lieu/organisme</label>
            <input type="text" formControlName="place" class="form-control" [class.is-invalid]="submitted && group.controls?.place?.invalid" />
            @if (submitted && group?.controls?.deadline?.errors?.maxlength) {
              <small class="form-text text-danger">La taille maximale est de 30 caracteres.</small>
            }
          </div>
          <!-- fulfilled -->
          <div class="text-secondary mb-4 col-12 col-lg-2" [formGroup]="group">
            <label>Réalisé</label>
            <select class="form-select" formControlName="fulfilled">
              <option [ngValue]="null"></option>
              <option [ngValue]="true">Oui</option>
              <option [ngValue]="false">Non</option>
            </select>
          </div>
          <!-- unfulfilled detail -->
          <div class="text-secondary mb-4 col-12 col-lg-10" [formGroup]="group">
            <label>Si non, pourquoi</label>
            <div class="input-group">
              <input
                type="text"
                formControlName="unfulfilledDetail"
                class="form-control"
                [class.is-invalid]="submitted && group.controls?.unfulfilledDetail?.invalid"
              />
              @if (submitted && group?.controls?.unfulfilledDetail?.errors?.maxlength) {
                <small class="form-text text-danger">La taille maximale est de 30 caracteres.</small>
              }
              <button
                type="button"
                ngbTooltip="Supprimer"
                placement="left"
                class="btn btn-outline-primary rounded"
                [disabled]="contractForm.controls.beginDate.disabled"
                (click)="groupRemoved(groupIndex)"
              >
                <fa-icon icon="trash-alt"></fa-icon>
              </button>
            </div>
          </div>
        </ng-template>
      </app-dynamic-form>
    </div>
    <hr />
    <div class="row">
      <div class="col-12">
        <label class="text-secondary">Remarques / préconisations du référent sur l'accompagnement : </label>
        <textarea class="form-control" formControlName="comment"></textarea>
      </div>
    </div>
    <div class="row mt-4 d-flex justify-content-end">
      <div class="d-grid col-3 col-md-6 col-lg-3 mb-1">
        @if (contract()?.id) {
          <button
            class="btn btn-primary d-flex justify-content-center"
            type="button"
            (click)="delete()"
            *hasPermission="$any('CAN_DELETE'); subject: contract(); context: workflowedContractPermissionContext"
          >
            <fa-icon icon="trash"></fa-icon>
            <span class="ms-3 d-none d-md-block">Supprimer</span>
          </button>
        }
      </div>
      <div class="d-grid col-3 col-md-6 col-lg-3 mb-1">
        <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="closeModal.emit()">
          <fa-icon icon="ban"></fa-icon>
          <span class="ms-3 d-none d-md-block">Annuler</span>
        </button>
      </div>
      @if (!contract()?.id) {
        <div class="d-grid col-3 col-md-6 col-lg-3 mb-1">
          <button class="btn btn-primary d-flex justify-content-center" type="submit">
            <fa-icon icon="save"></fa-icon>
            <span class="ms-3 d-none d-md-block">Sauvegarder</span>
          </button>
        </div>
      } @else {
        <div class="col-3 col-md-6 col-lg-3 mb-1">
          <div ngbDropdown>
            <button class="btn btn-primary" id="dropdownPrint" type="button" ngbDropdownToggle>
              <fa-icon icon="directions"></fa-icon>
              <span class="mx-3">Actions</span>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownPrint">
              <button
                class="dropdown-item"
                type="submit"
                *hasPermission="$any('CAN_EDIT'); subject: contract(); context: workflowedContractPermissionContext"
              >
                Sauvegarder
              </button>
              <button
                class="dropdown-item"
                type="button"
                (click)="saveContractAction()"
                *hasPermission="
                  $any(workflowedContractPermissionContext + '_CAN_EDIT_ACTION');
                  subject: contract();
                  context: workflowedContractPermissionContext
                "
              >
                Sauvegarder
              </button>
              <button
                class="dropdown-item"
                TERRITORY_VALIDATE
                type="button"
                (click)="generateContratEngagementDocument()"
                *hasPermission="$any('CAN_GENERATE'); subject: contract(); context: workflowedContractPermissionContext"
              >
                Générer
              </button>
              <button
                class="dropdown-item"
                type="button"
                (click)="workflowAction(traceabilityStatus.SignedBeneficiary)"
                *hasPermission="
                  $any(workflowedContractPermissionContext + '_CAN_BENEF_SIGN');
                  subject: contract();
                  context: workflowedContractPermissionContext
                "
              >
                Signer
              </button>
              <button
                class="dropdown-item"
                type="button"
                (click)="workflowAction(traceabilityStatus.ValidatedTerritory)"
                *hasPermission="
                  $any(workflowedContractPermissionContext + '_CAN_TERRITORY_VALIDATE');
                  subject: contract();
                  context: workflowedContractPermissionContext
                "
              >
                Valider
              </button>
              <button
                class="dropdown-item"
                type="button"
                (click)="workflowAction(traceabilityStatus.Unvalidated)"
                *hasPermission="
                  $any(workflowedContractPermissionContext + '_CAN_REJECT');
                  subject: contract();
                  context: workflowedContractPermissionContext
                "
              >
                Rejeter
              </button>
              <button
                class="dropdown-item"
                type="button"
                (click)="workflowAction(traceabilityStatus.SignedTerritory)"
                *hasPermission="
                  $any(workflowedContractPermissionContext + '_CAN_TERRITORY_SIGN');
                  subject: contract();
                  context: workflowedContractPermissionContext
                "
              >
                Signer
              </button>
              <button
                class="dropdown-item"
                type="button"
                (click)="workflowAction(traceabilityStatus.ValidatedDie)"
                *hasPermission="
                  $any(workflowedContractPermissionContext + '_CAN_DIRECTORY_VALIDATE');
                  subject: contract();
                  context: workflowedContractPermissionContext
                "
              >
                Valider
              </button>
              <button
                class="dropdown-item"
                type="button"
                (click)="workflowAction(traceabilityStatus.SignedDie)"
                *hasPermission="
                  $any(workflowedContractPermissionContext + '_CAN_DIRECTORY_SIGN');
                  subject: contract();
                  context: workflowedContractPermissionContext
                "
              >
                Signer
              </button>
              <button
                class="dropdown-item"
                type="button"
                (click)="workflowAction(traceabilityStatus.Done)"
                *hasPermission="
                  $any(workflowedContractPermissionContext + '_CAN_CLOSE');
                  subject: contract();
                  context: workflowedContractPermissionContext
                "
              >
                Sauvegarder & Terminer
              </button>
              <button
                class="dropdown-item"
                type="button"
                (click)="reopenContract()"
                *hasPermission="
                  $any(workflowedContractPermissionContext + '_CAN_REOPEN');
                  subject: contract();
                  context: workflowedContractPermissionContext
                "
              >
                Rouvrir le contrat
              </button>
              <button
                class="dropdown-item"
                type="button"
                (click)="workflowAction(traceabilityStatus.Creation)"
                *hasPermission="
                  $any(workflowedContractPermissionContext + '_CAN_ROLLBACK');
                  subject: contract();
                  context: workflowedContractPermissionContext
                "
              >
                Retour en Création
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  </form>
}
